import { useMemo } from 'react';
import {
  getOriginRoomLink,
  stripUrlSearchAndHash,
} from '../../../lib/helper/RoomHelper';

export type UseSectionDeepLinkBaseUrlParams = {
  canonicalRoomLink?: string;
  fallbackUrl?: string;
  roomUuid?: string;
};

export const useSectionDeepLinkBaseUrl = ({
  canonicalRoomLink,
  fallbackUrl,
  roomUuid,
}: UseSectionDeepLinkBaseUrlParams): string =>
  useMemo(() => {
    const trimmed = canonicalRoomLink?.trim();
    if (trimmed) {
      return stripUrlSearchAndHash(trimmed);
    }
    const uuid = roomUuid?.trim();
    if (uuid) {
      return getOriginRoomLink(uuid);
    }
    const fallback = fallbackUrl?.trim();
    if (fallback) {
      return stripUrlSearchAndHash(fallback);
    }
    return '';
  }, [canonicalRoomLink, fallbackUrl, roomUuid]);
